<template>
  <div class="features__list">
    <FeatureItem
      v-for="(feature, index) in features"
      :key="index"
      :feature="parseFeature(feature)"
      :class="{ feature__reverse_layout: (index + 1) % 2 === 0 }"
    />
  </div>
</template>

<script>
import FeatureItem from './FeatureItem'
import { Feature } from '../model/Feature'
export default {
  name: 'FeaturesList',
  components: {
    FeatureItem,
  },
  data() {
    return {
      features: [
        {
          tag: this.$t('features.title_small_1'),
          title: this.$t('features.title_1'),
          text: this.$t('features.content_1'),
          iconList: ['pen', 'screen_share', 'slides', 'students'],
          mediaResource: require('./../assets/v2.0/asset-2.webm'),
          mediaAlternative: require('./../assets/v2.0/asset-2.mp4'),
        },
        {
          tag: this.$t('features.title_small_2'),
          title: this.$t('features.title_2'),
          text: this.$t('features.content_2'),
          iconList: ['camera', 'board', 'chat', 'attach'],
          mediaResource: require('./../assets/v2.0/asset-3.webm'),
          mediaAlternative: require('./../assets/v2.0/asset-3.mp4'),
        },
        {
          tag: this.$t('features.title_small_3'),
          title: this.$t('features.title_3'),
          text: this.$t('features.content_3'),
          iconList: ['pen', 'screen_share', 'slides', 'students'],
          mediaResource: require('./../assets/v2.0/asset-4.webm'),
          mediaAlternative: require('./../assets/v2.0/asset-4.mp4'),
        },
      ],
    }
  },
  methods: {
    parseFeature(feature) {
      return new Feature(
        feature.tag,
        feature.title,
        feature.text,
        feature.iconList,
        feature.mediaResource,
        feature.mediaAlternative
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.features__list {
  display: grid;
  grid-template-rows: 1fr;
  row-gap: 104px;
  width: 80%;
  max-width: 1445px;
  margin: auto;
}

@media only screen and (max-width: 768px) {
  .features__list {
    row-gap: 32px;
    width: 100%;
    max-width: 100%;
  }
}
</style>

<style>
.feature__reverse_layout > div:first-child {
  order: 2;
}

.feature__reverse_layout > div:last-child {
  order: 1;
}

@media only screen and (max-width: 768px) {
  .feature__reverse_layout > div:first-child {
    order: 1;
  }

  .feature__reverse_layout > div:last-child {
    order: 2;
  }
}
</style>
